import { useState, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom'
import { StyledSignUpPage } from "../styles/signUpPage.styled";
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { UserContext } from "../contexts/userContext"
import BASE_URL from "../helpers/axios";

function Login() {
  const { userDispatch } = useContext(UserContext)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)
  const [loading, setIsloading] = useState(false);
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsloading(true)
    setError('')

    if (!password || !email) {
      setError("fill required fields")
      setIsloading(false)
      setTimeout(() => {
        setError('')
      }, 3000);
      return false;
    }

    const data = JSON.stringify({email,password})
    try {
      const res = await axios.post(`${BASE_URL}/api/users/login`,data, {
        headers: {
            'Content-Type': 'application/json'
        }
      })
      if (res) {
        setIsloading(false)
      const user = { username: res.data.user.user_name, token: res.data.token }
      localStorage.setItem("user", JSON.stringify(user))
      userDispatch({type: "LOGIN", payload: user})
      }
      navigate("/home/public")
    } catch (err) {
      setError("Invalid Login Credentials")
      setIsloading(false)
    }
    setTimeout(() => {
      setError('')
      },3000)
      setEmail('')
      setPassword('')
    }

  return (
    <div>
      <StyledSignUpPage>
        <form className="signup" onSubmit={handleSubmit}>
          <h3>Login</h3>
          <p>Check out the latest at Flash😁.</p>
          <div className="email field">
            <label>Email:</label>
            <input
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              required
            />
          </div>
          <div className="password-field field">
            <label>Password:</label>
            <input
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              required
            />
          </div>
          {error && <p style={{ color: "red" }}> {error}</p>}
          {loading ? <button className="signup-btn" disabled>Just a Sec...</button> : <button className="signup-btn">Login</button>}
          <p>
            Don't have an account? <Link to="/signup">Sign Up</Link>
          </p>
        </form>
        <ToastContainer />
      </StyledSignUpPage>
    </div>
  );
}

export default Login;
